import {
  SD_849_RECORD_PERMISSION,
  SD_849_REVIEW_SURFACE_PERMISSION,
} from '@erp/authz';
import { useCan } from '@/hooks/useCan';

/**
 * Whether the current user can work the 849 review surface — the same
 * `SD_849_REVIEW_SURFACE_ACCESS` its route guard and every handler on it check
 * (#7656): the record's Read plus the one surface permission. False while
 * loading.
 */
export function useCanReview(): boolean {
  const [canRead] = useCan(
    SD_849_RECORD_PERMISSION.action,
    SD_849_RECORD_PERMISSION.subject,
  );
  const [canUseSurface] = useCan(
    SD_849_REVIEW_SURFACE_PERMISSION.action,
    SD_849_REVIEW_SURFACE_PERMISSION.subject,
  );
  return canRead && canUseSurface;
}
